import { render, staticRenderFns } from "./LandingScreen.vue?vue&type=template&id=1163dc17&scoped=true&"
import script from "./LandingScreen.vue?vue&type=script&lang=js&"
export * from "./LandingScreen.vue?vue&type=script&lang=js&"
import style0 from "./LandingScreen.vue?vue&type=style&index=0&id=1163dc17&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1163dc17",
  null
  
)

export default component.exports